import { Component, OnInit, ViewChild, ElementRef, Input, NgZone, ViewContainerRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { ISubscription } from 'rxjs/Subscription';
import * as $ from 'jquery'
import { AccountingLogService } from '@fs/services/accounting-log';
import { IntegrationCommandModel } from '@fs/models/accounting-log/integrationCommands.model';
import { NotificationsService } from '@shared/services/notification';
import { CommonMethods } from '@services/common.method';
import { Constants } from '@constants';
import { Tabs } from '@enums/tab.enum';
import { TabType } from '@fs/enums/common';
import { CustomerService } from '@fs/services/customer';
import { TabOpenService } from '@services/tab-open.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Grid } from '@fs/enums/grid.enum';
import { FsUtil } from '@fs/services/fs-utils';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
declare var SimpleBar: any;

@Component({
  selector: 'app-accounting-log',
  templateUrl: './accounting-log.component.html',
  styleUrls: ['./accounting-log.component.scss']
})
export class AccountingLogComponent implements OnInit {

  //#region Input/Output/ViewChild
  @ViewChild('searchValue') searchValue: ElementRef;
  @ViewChild("ElAdvancedSearchOption") ElAdvancedSearchOption: any;
  @ViewChild("ElAdvancedSearch") ElAdvancedSearch: ElementRef;
  @ViewChild('grid') grid: any;
  @ViewChild("itemNotesGrid") itemNotesGrid: any;
  @ViewChild("kendogrid", {
    read: ViewContainerRef
  }) kendogrid: ViewContainerRef;
  //#endregion

  //#region Variable Declarations
  private k_grid: any;
  private autoRefreshTimer;
  /** Flag is used to check if api hit is required when quickSearch length is 0 */
  private triggerRefresh: boolean = false;

  /* use when default sort is desc order */
  private oppositeDefaultSort: any = [{
    field: 'SubmittedDate',
    dir: 'asc'
  }];

  public searchKey: string = "";
  public isAutoRefresh: boolean = false;
  public tabCounter: number;
  public listGetSubscription: ISubscription;
  public advancedFilterFields = [];
  public listOfIntegrations: IntegrationCommandModel[] = [];
  public pageSizes = { pageSizes: [25, 100, 300], refresh: true };
  public items: GridDataResult = { data: [], total: 0 };
  public customFilterForm: FormGroup;
  public defaultSort: any[] = [];
  public state = FsUtil.setGridState(Grid.AccountingLog);
  public showNoRecord : boolean = true;
  protected makeSearchRequest$ = new Subject();
  //#endregion

  //#region Constructor
  constructor(
    private frmbuilder: FormBuilder,
    private accountingLogService: AccountingLogService,
    private zone: NgZone,
    private _elementRef: ElementRef,
    private toastr: NotificationsService,
    private commonMethod: CommonMethods,
    private httpCustomerService: CustomerService,
    private tabopen: TabOpenService,
    private showspinner: SpinnerService) {
      FsUtil.configSort(this.defaultSort, Grid.AccountingLog);//Requires some cleanup
      FsUtil.configFilters(this.advancedFilterFields, Grid.AccountingLog);
      this.IntializeFilters();
      // Temproary solution
      this.makeSearchRequest$.pipe(debounceTime(Constants.debounceInterval))
      .subscribe(() => {
        this.GetIntegraionsList(true, 0);
      });
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.GetIntegraionsList();
  }
  //#endregion

  //#region Methods
  public DataStateChange(state: DataStateChangeEvent): void {
    /* use for any other case */
    //state.sort = state.sort != null ? (state.sort[0].dir == undefined ? this.defaultSort : state.sort) : null;

    /* use when default sort is desc order */
    state.sort = state.sort != null ? (state.sort[0].dir == undefined ? (state.sort[0].field != "SubmittedDate" ? this.defaultSort : this.oppositeDefaultSort) : state.sort) : null;
    this.state = state;
    this.GetIntegraionsList();
  }

  public RefreshGrid(event = null) {
    if (event != null)
      event.preventDefault();
    this.GetIntegraionsList(true,0);
  }

  public ToggleAdvanceSearch() {
    this.ElAdvancedSearchOption.DisplayToggle();
    $(this.ElAdvancedSearch.nativeElement).toggleClass("search__hidden");
  }

  public QuickSearch() {
    let searchString = this.customFilterForm.controls['searchString'].value;
    if (searchString.trim() == "" && this.triggerRefresh) {
      this.searchKey = "";
      this.resetState();
      this.showNoRecord = this.showspinner.showloader(this.kendogrid, this.tabCounter, 0, true, this.items.total);
      this.makeSearchRequest$.next();
    }
    else {
      this.searchKey = searchString.toUpperCase();
      if (searchString.length > 2)
        this.resetState();
        this.showNoRecord = this.showspinner.showloader(this.kendogrid, this.tabCounter, 0, true, this.items.total);
        this.makeSearchRequest$.next();
    }
  }

  public ClearQuickSearch() {
    this.customFilterForm.controls['searchString'].patchValue("");
    this.SetFilters({ advanceFilterActive: null, applyAdvanceFilter: false }, true);
  }

  public SetFilters(setFilterBtn: { applyAdvanceFilter: boolean, advanceFilterActive: any } = { advanceFilterActive: true, applyAdvanceFilter: null }, isStateReset: boolean = false) {
    let filterArray = <FormArray>this.customFilterForm.controls['searchFilters'];
    let searchKey = this.customFilterForm.controls['searchString'].value;
    //this.quickSearch();
    if (setFilterBtn.applyAdvanceFilter) {
      this.state.filter = { logic: 'or', filters: filterArray.value.filter(x => x.field != "") };
      this.commonMethod.FilterConverter(this.state.filter.filters);
      if (setFilterBtn.advanceFilterActive) {
        $(this.ElAdvancedSearch.nativeElement).addClass("active")
      }
      else {
        $(this.ElAdvancedSearch.nativeElement).removeClass("active")
      }
      this.resetState();
      isStateReset = false;
    }
    if (isStateReset)
      this.resetState();

    this.GetIntegraionsList();
  }

  public OnExpand() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this).parents('.k-master-row').addClass("active");
    });
  }

  public OnCollapse() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this).parents('.k-master-row').removeClass("active");
    });
  }

  public ReIntializeScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar($(this._elementRef.nativeElement).find('.k-grid-aria-root')[0], { autoHide: false });
    });
  }

  public AutoRefresh(value) {
    this.isAutoRefresh = value;
    if (this.isAutoRefresh) {
      this.autoRefreshTimer = setInterval(() => {
        this.GetIntegraionsList(false);
      }, 30000);
    }
    else {
      clearInterval(this.autoRefreshTimer);
    }
  }

  public RefreshRow(dataItem) {
    this.showspinner.showloader(this.kendogrid, this.tabCounter, 0);
    this.accountingLogService.GetIntegration({ ID: dataItem.ID }).subscribe((response) => {
      if (response != null) {
        let updatedRow: IntegrationCommandModel = response;
        let idx = this.listOfIntegrations.findIndex(x => x.ID == updatedRow.ID);
        this.listOfIntegrations[idx] = updatedRow;
        this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
      }
      else
        this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
    }, error => {
      this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
    });
  }

  public PostIntegration(dataItem) {
    this.showspinner.showloader(this.kendogrid, this.tabCounter, 0);
    this.accountingLogService.PostIntegration({ EntityID: dataItem.EntityID, EntityName: dataItem.EntityName }).subscribe((response) => {
      if (response != null) { };
      this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
      this.toastr.success("Posted to accounting");
    }, error => {
      this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
            if (!CommonMethods.CheckNullOrUndefined(error.error, true))
        this.toastr.showMultiLineError(
          error.error.Message,
          "Error"
        );
    });
  }

  public OpenEntityTab(dataItem) {
    let entityName = dataItem.EntityName.toLocaleLowerCase();
    let workOrderID = dataItem.CommonWorkTicketID;
    let tabTitle = dataItem.CommonData;
    let customerID = dataItem.CommonCustomerID;
    let jobSiteID = dataItem.CommonJobSiteID;
    
    switch (entityName) {
      case Constants.EntityName().Customer:
        this.GetCustomerJobSite(customerID, "", tabTitle, TabType.CustomerBilling);
        break;
      case Constants.EntityName().JobSite:
        this.GetCustomerJobSite(customerID, jobSiteID, tabTitle, TabType.JobSite);
        break;
      case Constants.EntityName().Invoice:
        this.OpenWorkOrderTab(workOrderID, tabTitle, customerID, jobSiteID)
        break;
      case Constants.EntityName().Payment:
        this.OpenWorkOrderTab(workOrderID, tabTitle, customerID, jobSiteID)
        break;
      default:
        break;
    }
  }

  private IntializeFilters() {
    this.customFilterForm = this.frmbuilder.group({
      "searchFilters": this.frmbuilder.array([]),
      "searchString": new FormControl(""),
    });
  }

  private GetIntegraionsList(showSpinner = true,instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    if(showSpinner)
      this.showNoRecord = this.showspinner.showloader(this.kendogrid, this.tabCounter, instantSpinnerTime, true, this.items.total);
    else
      this.showspinner.hideLoader(this.kendogrid, this.tabCounter);

    let searchKey = this.customFilterForm.controls['searchString'].value.trim();
    this.triggerRefresh = searchKey.length > 2 ? true : (searchKey.length == 0) ? false : this.triggerRefresh;
    if (this.listGetSubscription != null && this.listGetSubscription != undefined) {
      this.listGetSubscription.unsubscribe();
    }
    this.listGetSubscription =
      this.accountingLogService.GetIntegrations(this.state, searchKey).subscribe(response => {
        if (response != null) {
          this.listOfIntegrations = response.integrationCommands;
          if (response.integrationCommands.length > 0) {
            this.accountingLogService.FetchIntegrations(response, this.state, this.state.sort)
              .subscribe(r => {
                this.items = r;
                this.showNoRecord = this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
              });
          }
          else {
            this.items.data = [];
            this.items.total = 0;
            this.showNoRecord = this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
          }
        }
      }, error => {
        this.showNoRecord = this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
      });
  }

  private OpenCustomerJobSiteTab(detailData, jobSiteID, tabTitle, tabType: TabType) {
    let customerData = Object.assign({}, detailData);
    customerData.JobSites = [];
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteCustomerJobSiteEdit,
      params: {
        ID: jobSiteID,
        jobsiteId: jobSiteID,
        objDetailData: customerData,
        previewType: tabType == TabType.CustomerBilling ? "billing" : "jobsite"
      },
      tabTitle: "Job Site - " + tabTitle,
      replaceIfOpen: {
        replaceTab: true,
        tabToReplace: Tabs.FsLiteCustomerJobSiteEdit,
        action: "focus"
      }
    });
  }

  private OpenWorkOrderTab(workOrderID, WorkTicketNo, customerID, jobSiteID) {
    let params = {
      ID: workOrderID,
      customerId: customerID,
      jobsiteId: jobSiteID
    }
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderView,
      params: params,
      tabTitle: WorkTicketNo
    })
  }

  private GetCustomerJobSite(customerID, jobSiteID, tabTitle, entityType: TabType) {
    let detailData: any;
    if (!CommonMethods.CheckNullOrUndefined(customerID)) {
      this.showspinner.showloader(this.kendogrid, this.tabCounter,0);
      if (entityType == TabType.JobSite && !CommonMethods.CheckNullOrUndefined(jobSiteID)) {
        this.httpCustomerService.GetJobSiteDetail(customerID, jobSiteID, "Customer,TaxGroup,Contacts,PaymentTerm").subscribe(response => {
          if (response != null) {
            if (response.Customer != null) {
              detailData = response.Customer;
              response.Customer = null;
            }
            detailData.JobSites = [response];
            this.OpenCustomerJobSiteTab(detailData, jobSiteID, tabTitle, TabType.JobSite);
            this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
          }
          this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
        }, error => {
          this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
        });
      }
      else {
        this.httpCustomerService.GetBillingDetail(customerID, "Contacts,jobsites,PaymentTerm").subscribe(response => {
          detailData = response;
          if (!CommonMethods.CheckNullOrUndefined(detailData.JobSites, true)) {
            let jobSite = detailData.JobSites.find(x => x.IsDefault);
            if (!CommonMethods.CheckNullOrUndefined(jobSite)) {
              jobSiteID = jobSite.ID;
            }
          }
          this.OpenCustomerJobSiteTab(detailData, jobSiteID, tabTitle, TabType.CustomerBilling);
          this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
        }, error => {
          this.showspinner.hideLoader(this.kendogrid, this.tabCounter);
        });
      }
    }
  }
  
  private resetState(){
    this.state.skip = 0;
    this.state.take = 25;
  }
  //#endregion
}
